import { Action } from 'redux';

import { ILabelValueInfo } from '~src/catalog/models/ILabelValueInfo';

import { SetCertificationOrTriggerWarning } from '../../../bootstrap/redux/actions/AppActionTypes';


export interface SetCertificationOrTriggerWarningAction extends Action {
    item: ILabelValueInfo;
}

export function setCertificationOrTriggerWarningAction(item: SetCertificationOrTriggerWarningAction['item']): SetCertificationOrTriggerWarningAction {
    return {
        type: SetCertificationOrTriggerWarning,
        item
    };
}
